<template>
  <CustomCarousel ref="carousel">
    <template v-slot:slide-0>
      <div class="signature-container">
        <div v-if="!errorMessage">
          <h1>Signature électronique</h1>
          <p>Vos informations numériques : {{signatureData.ip}} | {{signatureData.city}}, {{signatureData.region}}, {{signatureData.country}}</p>
          <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
            <CustomTextField :content=inputs.name />
            <CustomTextField :content=inputs.email />
            <div class="consent-container">
              <CustomSwitchField :content=inputs.consent />
              <p>J'accepte ce devis et je donne mon accord pour sa signature électronique</p>
            </div>
            <CustomButton @click="sign" :params=submitParams />
          </CustomForm>
        </div>
        <div v-else>
          <p>{{errorMessage}}</p>
        </div>
      </div>
    </template>
    <template v-slot:slide-1>
      <div class="check-message-container">
        <img src="/img/check.png" alt="Validé">
        <p>Signature confirmée. Vous allez recevoir un e-mail contenant le document signé ainsi que les informations de signature.</p>
      </div>
    </template>
  </CustomCarousel>
</template>

<script>
import {BusinessController} from "@/controllers/business/BusinessController";
import {UserController} from "@/controllers/user/UserController";
import CustomCarousel from "@/components/CustomCarousel.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomSwitchField from "@/components/forms/customs/customSwitchField/CustomSwitchField.vue";

export default {
  name: 'BusinessSignatureView',
  components: {CustomSwitchField, CustomButton, CustomForm, CustomTextField, CustomCarousel},
  data() {
    return {
      inputs: {
        email: {label: 'Email', value: '', type: 'text'},
        name: {label: 'Prénom ou Raison social', value: '', type: 'text'},
        consent: {value: false, left: {label: "", value: false}, right: {label: "", value: true}, lightMode: true},
      },
      buttons:{
        submit: {text: "Signer"}
      },
      errorMessage: undefined,
      business: undefined,
      signatureData: {
        userAgent: '',
        ip: '',
        city: '',
        region: '',
        country: '',
      },
    };
  },
  computed: {
    submitParams() {
      const disabled = !this.inputs.consent.value || !this.inputs.email.value || !this.inputs.name.value
      return {
        ...this.buttons.submit,
        disabled: disabled,
      };
    },
  },
  async mounted() {
    const resp = await BusinessController.getBySignature(this.$route.params.hash);
    if (!resp.errors) {
      this.business = resp;
    } else {
      this.errorMessage = resp.errors[0].message;
    }

    this.signatureData.userAgent = navigator.userAgent;

    const resp2 = await UserController.clientInfo();
    if (!resp2.errors) {
      this.signatureData.ip = resp2.ip;
      this.signatureData.city = resp2.city;
      this.signatureData.region = resp2.region;
      this.signatureData.country = resp2.country;
    } else {
      this.errorMessage = "Impossible de récupérer vos informations (IP et géolocalisation)";
    }
  },
  methods: {
    async sign() {
      const resp = await BusinessController.sign(this.$route.params.hash, {
        email: this.inputs.email.value,
        consent: this.inputs.consent.value,
        name: this.inputs.name.value,
        ip: this.signatureData.ip,
        country: this.signatureData.country,
        region: this.signatureData.region,
        city: this.signatureData.city,
        userAgent : this.signatureData.userAgent,
      });
      if (!resp.errors) {
        this.$refs.carousel.goToSlide(1);
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl'
  .signature-container
    width 90%
    max-width 450px
    .consent-container
      display flex
      gap 15px
      margin-top 15px
      margin-bottom 15px

  .check-message-container
    display flex
    flex-direction column
    align-items center
    max-width 400px
    img
      width 150px
      height 150px
    p
      font-weight bold
      font-size 1.1em
</style>
